import * as React from "react";
function SvgClose(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle cx={16} cy={16} r={16} />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={4}
        d="M10 10l12 12M22 10L10 22"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgClose);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
